export const getStepConfig = (
	labels = {},
	oemCount = 1,
	make = '',
	model = '',
	trim = '',
	drivetrain = '',
	cab = '',
	paint = '',
	rootDir = ''
) => {
	const rootFile = 'index.htm';

	const rootPath = `/${rootDir}/${rootFile}`;
	const configurationParams = cab
		? `driveTrain=${drivetrain}&cabId=${cab}`
		: `driveTrain=${drivetrain}`;

	const steps = [
		{
			name: 'make',
			nextPath: `/${rootDir}/${make}.htm`,
			heading: oemCount > 1 ? 'CHOOSE_YOUR_MAKE' : '',
			showContinue: false,
			showBack: false,
			showVehicleCard: false,
			useTray: false,
			flexClass: 'flex-row'
		},
		{
			name: 'model',
			nextPath: `/${rootDir}/${make}/${model}.htm`,
			heading: labels
				.get('CHOOSE_YOUR_MAKE_MODEL')
				.replace('[MAKE]', make),
			showContinue: false,
			showBack: true,
			showVehicleCard: false,
			useTray: false,
			flexClass: 'flex-row'
		},
		{
			name: 'trim',
			nextPath: `/${rootDir}/${make}/${model}.htm?trim=${trim}`,
			heading: labels.get('CHOOSE_YOUR_TRIM'),
			showContinue: true,
			showBack: true,
			showVehicleCard: true,
			useTray: true,
			flexClass: 'flex-row'
		},
		{
			name: 'configuration',
			nextPath: `/${rootDir}/${make}/${model}.htm?trim=${trim}&${configurationParams}`,
			heading: labels.get('CHOOSE_YOUR_CONFIGURATION'),
			showContinue: true,
			showBack: true,
			showVehicleCard: true,
			useTray: true,
			flexClass: 'flex-row'
		},
		{
			name: 'color',
			nextPath: `/${rootDir}/${make}/${model}.htm?trim=${trim}&${configurationParams}&paint=${paint}`,
			heading: labels.get('CHOOSE_YOUR_PAINT'),
			showContinue: true,
			showBack: true,
			showVehicleCard: true,
			useTray: true,
			flexClass: 'flex-row'
		},
		{
			name: 'packages',
			nextPath: `/${rootDir}/${make}/${model}/form.htm`,
			heading: 'Add Your Packages',
			showContinue: true,
			showBack: true,
			showVehicleCard: true,
			useTray: true,
			flexClass: 'flex-row'
		},
		{
			name: 'form',
			nextPath: `/${rootDir}/${make}/${model}/confirm.htm`,
			heading: labels.get('CAR_CUSTOMIZER_SUBMIT'),
			showContinue: false,
			showBack: true,
			showVehicleCard: true,
			useTray: false,
			flexClass: 'flex-row-reverse flex-wrap-reverse'
		},
		{
			name: 'confirm',
			showContinue: false,
			showBack: false,
			showVehicleCard: true,
			useTray: false,
			flexClass: 'flex-row-reverse flex-wrap'
		}
	];

	return {
		rootPath,
		steps
	};
};
